// HEADER STYLE WHEN SCROLLING

if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
  let observer = new IntersectionObserver(entries => {
    if (entries[0].boundingClientRect.y < 0) {
      document.body.classList.add('detached-header');
    } else {
      document.body.classList.remove('detached-header');
    }
  });
  observer.observe(document.querySelector('#top-of-site-anchor'));
}

// ADD MEGAMENU CLASS ON HOVER

const hasMegaMenus = document.querySelectorAll('.has-mega-menu');
const header = document.querySelector('.main-navigation');

hasMegaMenus.forEach(hasMegaMenu => {
  hasMegaMenu.addEventListener('mouseenter', mOver, false);
  hasMegaMenu.addEventListener('mouseleave', mOut, false);
});

function mOver() {
  header.classList.add('mega-menu__active');
}

function mOut() {
  header.classList.remove('mega-menu__active');
}
